import Link from 'components/Basic/Link/Link';
import useTranslation from 'next-translate/useTranslation';
import { FileIcon } from 'public/svg/IconsSvg';
import { ProductFileType, ProductFileTypeType } from 'types/file';

type ProductFilesProps = {
    files: ProductFileType[];
};

const ProductFiles: FC<ProductFilesProps> = (props) => {
    const testIdentifier = 'pages-productdetail-files';
    const { t } = useTranslation();

    if (props.files.length === 0) {
        return null;
    }

    const getFileNameByType = (type: ProductFileTypeType | undefined, anchorText: string): string => {
        return type === 'ManualFile'
            ? t('Product file manual')
            : type === 'RecipeFile'
              ? t('Product file recipe')
              : type === 'ManualRecipeFile'
                ? t('Product file manual recipe')
                : anchorText;
    };

    return (
        <div className="vl:flex" data-testid={testIdentifier}>
            <h2 className="hidden basis-1/5 vl:block">{t('Product manuals')}</h2>
            <ul className="basis-4/5 pb-10 vl:pb-0">
                {props.files.map((file) => (
                    <li key={file.url}>
                        <Link
                            className="pb-2 text-body font-bold text-red vl:px-0 vl:py-2"
                            href={file.urlToOpen}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <>
                                <FileIcon className="text-red" />
                                {getFileNameByType(file.type, file.anchorText)}
                            </>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ProductFiles;
